import { render, staticRenderFns } from "./PopupVideo.vue?vue&type=template&id=953dbc20&scoped=true"
import script from "./PopupVideo.vue?vue&type=script&lang=js"
export * from "./PopupVideo.vue?vue&type=script&lang=js"
import style0 from "./PopupVideo.vue?vue&type=style&index=0&id=953dbc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953dbc20",
  null
  
)

export default component.exports